import React, {PropTypes, Component} from 'react'

class RegistrationStatus extends Component {
  constructor(props){
    super(props)
  }

  static propTypes = {
    attendeeInfo: PropTypes.object.isRequired
  }

  renderStatus(){
    const {attendeeInfo} = this.props
    const {state} = attendeeInfo

    if(state === 0){
      return(
        <div className='wait-list text-center'>{__('Waiting List', 'registrationTable')}</div>
      )
    } else if (state == 2){
      return(
        <div className='register-sucess text-center'>{__('Success', 'registrationTable')}</div>
      )
    } else if (state == 4){
      return(
        <div className='transferred text-center'>{__('Transferred', 'registrationTable')}</div>
      )
    }
  }

  render(){
    return(
      <div className='class-status'>
        {this.renderStatus()}
      </div>
    )
  }
}


export default (RegistrationStatus)



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/RegistrationTable/RegistrationStatus.js